module.exports = __webpack_public_path__ + "static/img/zncwm83.cc3c972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zncwm83.png
// module id = 6WpN
// module chunks = 73